<template>
	<div>
		<v-layout class="p-4 border-bottom-light-grey min-height-57px">
			<v-flex class="font-level-3-bold my-auto">
				<span class="detail-svg-icon mr-2">
					<!--begin::Svg Icon-->
					<inline-svg :src="$assetURL('media/custom-svg/services-color.svg')" />
					<!--end::Svg Icon-->
				</span>
				Services
			</v-flex>
			<v-flex class="text-right my-auto"> Total Services Cost: {{ totalCost }} </v-flex>
		</v-layout>
		<div class="overflow-y" style="max-height: calc(100vh - 306px)">
			<table class="line-item-multiple-table" width="100%">
				<thead>
					<tr>
						<th width="15%" class="p-2 light-blue-bg">Image</th>
						<th width="40%" class="p-2 light-blue-bg">Name</th>
						<th width="30%" class="p-2 light-blue-bg text-center">Barcode</th>

						<th width="10%" class="p-2 light-blue-bg">Quantity</th>
					</tr>
				</thead>
				<tbody v-if="inventories.length">
					<template v-for="(inventory, index) in inventories">
						<tr :key="index">
							<td class="p-2 border-top-light-grey">
								<ImageTemplate circle style="max-width: 50px" :src="inventory?.inventory?.image">
								</ImageTemplate>
							</td>

							<td class="px-2 pb-3 my-auto font-level-1 text-black border-top-light-grey">
								<p class="m-0 my-auto mt-3">{{ inventory.inventory.name }}</p>
							</td>
							<td class="px-2 py-2 my-auto font-level-1 text-black border-top-light-grey">
								<div
									v-if="inventory?.inventory?.pico_barcode"
									v-on:click="openPopup(inventory.inventory)"
									class="text-center"
								>
									<label class="font-size-14 mb-1">
										<v-icon size="30">mdi-barcode-scan</v-icon>
									</label>
									<div class="font-size-14 fw-600 mb-1 w-100">
										{{ inventory?.inventory?.pico_barcode }}
									</div>
								</div>
								<div v-else>
									<em class="text-muted">No Barcode</em>
								</div>
							</td>
							<td class="px-2 pb-3 font-level-1 text-black border-top-light-grey">
								{{ inventory.quantity }}
								<!-- <QuantityInput
													hide-details
													:disabled="pageLoading"
													:loading="pageLoading"
													placeholder="Quantity"
													v-model="inventoryList[index]?.quantity"
												></QuantityInput> -->
							</td>
						</tr>
					</template>
				</tbody>
				<tfoot v-else>
					<tr>
						<td colspan="5">
							<p class="m-0 row-not-found text-center fw-500 font-size-16">
								<img :src="$assetURL('media/error/empty.png')" class="row-not-found-image" />
								Uhh... There are no Perishables at the moment.
							</p>
						</td>
					</tr>
				</tfoot>
			</table>
		</div>
		<Dialog :dialog="detailDialog" :dialog-width="dialogWidth" dense>
			<template v-slot:title>
				<v-layout>
					<v-flex md4 class="my-auto"> {{ service.service_type }} Service </v-flex>
					<v-flex md8 class="text-right">
						<v-btn
							v-if="service.status == 3"
							color="blue darken-4 text-white"
							class="mr-2"
							depressed
							v-on:click="startScheduledService"
							tile
							><v-icon small left>mdi-hammer-wrench</v-icon>Start</v-btn
						>
						<v-btn
							v-if="service.status == 1"
							v-on:click="serviceCompleteDialog = true"
							color="blue darken-4 text-white"
							class="mx-2"
							depressed
							tile
							><v-icon small left>mdi-format-list-checks</v-icon>Complete</v-btn
						>
						<v-btn
							v-if="service.status == 1"
							v-on:click="serviceExtendDialog = true"
							color="blue darken-4 text-white"
							class="mx-2"
							depressed
							tile
							><v-icon small left>mdi-share-all-outline</v-icon>Extend</v-btn
						>
						<v-btn
							v-on:click="detailDialog = false"
							color="blue darken-4 text-white"
							class="ml-2"
							depressed
							tile
							><v-icon small left>mdi-close</v-icon>Close</v-btn
						>
					</v-flex>
				</v-layout>
			</template>
			<template v-slot:body>
				<div>
					<v-tabs
						v-model="serviceTab"
						background-color="transparent"
						color="blue"
						class="custom-tab-transparent"
						active-class="blue darken-4 text-white"
						hide-slider
					>
						<v-tab href="#detail">
							<span class="tab-svg-icon mr-2">
								<!--begin::Svg Icon-->
								<inline-svg :src="$assetURL('media/custom-svg/services.svg')" />
								<!--end::Svg Icon-->
							</span>
							Details
						</v-tab>
						<v-tab href="#linked-inventory" v-on:click="getLinkedInventories()">
							<span class="tab-svg-icon mr-2">
								<!--begin::Svg Icon-->
								<inline-svg :src="$assetURL('media/custom-svg/inventory.svg')" />
								<!--end::Svg Icon-->
							</span>
							Linked Perishables
						</v-tab>
						<v-tab href="#file"> <v-icon small left>mdi-file-document-multiple</v-icon> Files</v-tab>
						<v-tab href="#comment"> <v-icon small left>mdi-comment-multiple</v-icon> Comments</v-tab>
					</v-tabs>
					<v-tabs-items v-model="serviceTab">
						<v-tab-item value="detail">
							<div class="mx-4 mb-4">
								<div class="overflow-y" style="max-height: 600px; min-height: 400px">
									<v-layout class="p-4 border-bottom-light-grey min-height-57px">
										<v-flex class="font-level-3-bold my-auto">
											<span class="detail-svg-icon mr-2">
												<!--begin::Svg Icon-->
												<inline-svg :src="$assetURL('media/custom-svg/services-color.svg')" />
												<!--end::Svg Icon-->
											</span>
											Service Details
										</v-flex>
									</v-layout>
									<table width="100%" class="detail-table scattered-table">
										<tr>
											<th class="p-2" width="250px">Service Type</th>
											<td class="font-level-1 p-2">
												<ShowValue :object="service" object-key="service_type" label="service type"></ShowValue>
											</td>
											<th class="p-2" width="250px">Service Start Date (expected)</th>
											<td class="font-level-1 p-2">
												<ShowValue
													:object="service"
													object-key="expected_start_date_formatted"
													label="service start date (expected)"
												></ShowValue>
											</td>
										</tr>
										<tr>
											<th class="p-2" width="250px">Cost</th>
											<td class="font-level-1 p-2">
												<ShowValue :object="service" object-key="cost_formatted" label="Cost"></ShowValue>
											</td>
											<th class="p-2" width="250px">Service End Date (expected)</th>
											<td class="font-level-1 p-2">
												<ShowValue
													:object="service"
													object-key="expected_end_date_formatted"
													label="Service End Date (expected)"
												></ShowValue>
											</td>
										</tr>
										<tr>
											<th class="p-2" width="250px">Service By</th>
											<td class="font-level-1 p-2">
												<ShowValue
													:object="service"
													object-key="service_by_formatted"
													label="Service By"
												></ShowValue>
												(<ShowValue
													:object="service"
													v-if="service.service_by == 1"
													object-key="vendor_display_name"
													label="vendor"
												></ShowValue>
												<ShowValue
													:object="service"
													v-else
													object-key="member_display_name"
													label="member"
												></ShowValue
												>)
											</td>
											<th class="p-2" width="250px">Service Start Date (actual)</th>
											<td class="font-level-1 p-2">
												<ShowValue
													:object="service"
													object-key="actual_start_date_formatted"
													label="service start date (actual)"
												></ShowValue>
											</td>
										</tr>
										<tr>
											<th class="p-2" width="250px">Created By</th>
											<td class="font-level-1 p-2">
												<ShowValue :object="service" object-key="created_by" label="Created By"></ShowValue>
											</td>
											<th class="p-2" width="250px">Service End Date (actual)</th>
											<td class="font-level-1 p-2">
												<ShowValue
													:object="service"
													object-key="actual_end_date_formatted"
													label="Service End Date (actual)"
												></ShowValue>
											</td>
										</tr>
										<tr>
											<th class="p-2" width="250px">Location By</th>
											<td class="font-level-1 p-2">
												<ShowValue
													:object="service"
													object-key="location_by_formatted"
													label="Loaction By"
												></ShowValue>
											</td>
										</tr>

										<tr>
											<th class="p-2" width="250px">Description</th>
											<td class="font-level-1 p-2" colspan="3">
												<ShowValue :object="service" object-key="description" label="Description"></ShowValue>
											</td>
										</tr>
									</table>
								</div>
							</div>
						</v-tab-item>
						<v-tab-item value="linked-inventory">
							<div class="mx-4 mb-4">
								<v-layout class="p-4 border-bottom-light-grey min-height-57px">
									<v-flex md6 class="font-level-3-bold my-auto">
										<table width="100%">
											<tr>
												<td>
													<span class="detail-svg-icon mr-2">
														<!--begin::Svg Icon-->
														<inline-svg :src="$assetURL('media/custom-svg/inventory-color.svg')" />
														<!--end::Svg Icon-->
													</span>
												</td>
												<td>
													<p class="m-0 mb-2">Linked Perishables</p>
													<span class="font-small text-muted">
														<v-icon small>mdi-progress-question</v-icon> Items displayed here were consumed during
														the service.</span
													>
												</td>
											</tr>
										</table>
									</v-flex>
									<v-flex md6 class="font-level-3-bold my-auto text-right">
										<v-btn
											v-if="service.status != 2"
											v-on:click="inventoryDialog = true"
											color="blue darken-4 text-white"
											depressed
											tile
											><v-icon small left>mdi-playlist-plus</v-icon>Link Perishables Items</v-btn
										>
									</v-flex>
								</v-layout>
								<div
									class="overflow-y border-light-grey"
									style="max-height: calc(100vh - 250px); min-height: 400px"
								>
									<table width="100%" class="detail-table scattered-table table-head-sticky">
										<thead>
											<tr>
												<th class="p-2 light-blue-bg font-level-1-bold">Perishables #</th>
												<th class="p-2 light-blue-bg font-level-1-bold">Name</th>
												<th class="p-2 light-blue-bg font-level-1-bold">Quantity</th>
												<th v-if="false" class="p-2 light-blue-bg font-level-1-bold">Location</th>
												<th class="p-2 light-blue-bg font-level-1-bold">Date Added</th>
											</tr>
										</thead>
										<tbody v-if="linkedInventories.length">
											<tr v-for="(row, index) in linkedInventories" :key="index">
												<td class="border-top-light-grey border-right-light-grey font-level-1 p-2">
													<ShowValue
														:object="row"
														object-key="inventory_barcode"
														label="inventory #"
													></ShowValue>
												</td>
												<td class="border-top-light-grey border-right-light-grey font-level-1 p-2">
													<ShowValue :object="row" object-key="inventory_name" label="name"></ShowValue>
												</td>
												<td class="border-top-light-grey border-right-light-grey font-level-1 p-2">
													<ShowValue :object="row" object-key="quantity" label="quantity"></ShowValue>
												</td>
												<td v-if="false" class="border-top-light-grey border-right-light-grey font-level-1 p-2">
													<ShowValue :object="row" object-key="location_name" label="location"></ShowValue>
												</td>
												<td class="border-top-light-grey font-level-1 p-2">
													<ShowValue
														tooltip
														tooltip-value="added_at"
														:object="row"
														object-key="created_at"
														label="date added"
													></ShowValue>
												</td>
											</tr>
										</tbody>
										<tfoot v-else>
											<tr>
												<td colspan="5">
													<p class="m-0 row-not-found text-center">
														<img :src="$assetURL('media/error/empty.png')" class="row-not-found-image" />
														Uhh... There are no linked inventory at the moment.
													</p>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							</div>
						</v-tab-item>
						<v-tab-item value="file">
							<Files
								class="mx-4"
								type-text="Service Files"
								type="service"
								:type-uuid="service.uuid"
							></Files>
						</v-tab-item>
						<v-tab-item value="comment">
							<Comments
								class="mx-4"
								type-text="Service"
								type="service"
								:type-uuid="service.uuid"
							></Comments>
						</v-tab-item>
					</v-tabs-items>
				</div>
			</template>
		</Dialog>
		<Dialog :dialog="inventoryDialog" :dialog-width="dialogWidth - 200" dense>
			<template v-slot:title> Link Perishables Items </template>
			<template v-slot:body>
				<LinkAssetInventoryItem v-model="inventories" class="mx-4 mb-4"></LinkAssetInventoryItem>
			</template>
			<template v-slot:action>
				<v-btn v-on:click="closeLinkInventory()" color="blue darken-4 text-white" depressed tile
					>Close</v-btn
				>
				<v-btn v-on:click="linkInventory()" color="blue darken-4 text-white" depressed tile
					>Link Perishables</v-btn
				>
			</template>
		</Dialog>
		<ServiceCompleteTemplate
			type="Asset"
			endpoint="asset"
			:type-uuid="assetUuid"
			:service-uuid="service.uuid"
			v-on:success="
				serviceCompleteDialog = false;
				detailDialog = false;
				getServices();
			"
			v-on:close="serviceCompleteDialog = false"
			:service-dialog="serviceCompleteDialog"
		></ServiceCompleteTemplate>
		<ServiceExtendTemplate
			type="Asset"
			endpoint="asset"
			:type-uuid="assetUuid"
			:service-uuid="service.uuid"
			v-on:success="
				serviceExtendDialog = false;
				detailDialog = false;
				getServices();
			"
			v-on:close="serviceExtendDialog = false"
			:service-dialog="serviceExtendDialog"
		></ServiceExtendTemplate>
		<v-dialog
			origin="center center"
			v-model="barcodeDialog"
			persistent
			scrollable
			content-class="common-dialog"
			:max-width="500"
		>
			<v-card>
				<v-card-title
					class="headline dialog-custom-header text-uppercase custom-border-bottom custom-header-blue-text white-background"
				>
					{{ barcodeDialogTitle }}
				</v-card-title>
				<v-card-text>
					<div class="text-center mt-2">
						<img v-if="popup_image" class="mb-4" :src="popup_image" :alt="popup_text" width="400px" />
						<h3>{{ popup_text }}</h3>
					</div>
				</v-card-text>
				<v-divider class="my-0"></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn depressed tile v-on:click="barcodeDialog = false">Close </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { toSafeInteger } from "lodash";
import {
	GetAssetServicesInventories,
	AssetServiceLinkInventory,
	GetAssetServiceLinkInventory,
} from "@/core/lib/asset.lib";
import ShowValue from "@/view/components/ShowValue";
import Dialog from "@/view/components/Dialog";
import Comments from "@/view/components/Comments";
import Files from "@/view/components/Files";
import ServiceCompleteTemplate from "@/view/components/ServiceCompleteTemplate";
import ServiceExtendTemplate from "@/view/components/ServiceExtendTemplate";
import LinkAssetInventoryItem from "@/view/components/LinkAssetInventoryItem";
import { SET_ERROR, SET_MESSAGE } from "@/core/services/store/common.module";
import { EventBus } from "@/core/event-bus/event.bus";
import ApiService from "@/core/services/api.service";
import ImageTemplate from "@/view/components/Image";

export default {
	data() {
		return {
			linkedInventories: [],
			inventoryList: [],
			inventories: [],
			pageLoading: false,
			detailDialog: false,
			inventoryDialog: false,
			serviceCompleteDialog: false,
			serviceExtendDialog: false,
			searchLoading: false,
			formLoading: false,
			menuSearch: false,
			showingString: null,
			search: null,
			serviceTab: "detail",
			currentPage: 1,
			totalCost: 0,
			totalPage: 1,
			service: {},
			timeout: null,
			timeoutLimit: 500,
			barcodeDialog: false,
			barcodeDialogTitle: null,
			popup_image: null,
			popup_text: null,
		};
	},
	props: {
		assetUuid: {
			type: String,
			data: null,
		},
	},
	methods: {
		openPopup(data) {
			this.popup_image = data.barcode_image;
			this.popup_text = data.pico_barcode;

			this.barcodeDialogTitle = `${data.name ? data.name : ""} (#${data.barcode})`;
			this.barcodeDialog = true;
			return false;
		},
		closeLinkInventory() {
			this.inventoryList = [];
			this.inventories = [];
			this.inventoryDialog = false;
			this.searchLoading = false;
			this.formLoading = false;
			this.menuSearch = false;
			this.search = null;
		},
		startScheduledService() {
			this.pageLoading = true;
			ApiService.patch(`asset/${this.assetUuid}/service/${this.service.uuid}/start`)
				.then(() => {
					this.detailDialog = false;
					this.getServices();
				})
				.catch((error) => {
					this.$emit("error", error);
					this.logError(error);
				})
				.finally(() => {
					this.pageLoading = false;
				});
		},
		getLinkedInventories() {
			if (!this.service.uuid) {
				return false;
			}

			GetAssetServiceLinkInventory(this.assetUuid, this.service.uuid)
				.then((data) => {
					this.linkedInventories = data;
				})
				.catch((error) => {
					this.logError(error);
				});
		},
		linkInventory() {
			if (!this.service.uuid) {
				return false;
			}

			if (!this.inventories.length) {
				this.$store.commit(
					SET_ERROR,
					this.errors.concat([{ model: true, message: "Error ! Add atleast one inventory." }])
				);
				return false;
			}

			this.formLoading = true;
			AssetServiceLinkInventory(this.assetUuid, this.service.uuid, { inventory: this.inventories })
				.then((data) => {
					this.linkedInventories = data;
					this.closeLinkInventory();
					this.$store.commit(SET_MESSAGE, [
						{ model: true, message: "Success ! Perishables has been successfully linked to service." },
					]);
				})
				.catch((error) => {
					this.logError(error);
				})
				.finally(() => {
					this.formLoading = false;
				});
		},
		routeToDetail(row) {
			console.log({ row });
			this.service = row;
			this.detailDialog = true;
		},
		getInventories() {
			GetAssetServicesInventories(this.assetUuid)
				.then((data) => {
					this.inventories = data.tbody;
					this.showingString = data.showing_string;
					this.currentPage = data.current_page;
					this.totalCost = data.total_cost_formatted;
					this.totalPage = data.total_page;
				})
				.catch((error) => {
					this.logError(error);
				})
				.finally(() => {
					this.pageLoading = false;
				});
		},
	},
	components: {
		Dialog,
		ShowValue,
		Comments,
		Files,
		ServiceExtendTemplate,
		LinkAssetInventoryItem,
		ServiceCompleteTemplate,
		ImageTemplate,
	},
	mounted() {
		this.getInventories();

		EventBus.$on("reload:asset-service", () => {
			this.getServices();
		});
	},
	beforeDestroy() {
		EventBus.$off("reload:asset-service");
	},
	computed: {
		...mapGetters(["errors"]),
		dialogWidth() {
			return toSafeInteger((document.body.clientWidth / 100) * 65);
		},
	},
};
</script>
